module.exports = __webpack_public_path__ + "img/icon-databoard.21ea3f90.png";